import { render, staticRenderFns } from "./FacetItemText.vue?vue&type=template&id=01bc58d2&"
import script from "./FacetItemText.vue?vue&type=script&lang=js&"
export * from "./FacetItemText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports